var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "edit-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "70%",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "录入方式", prop: "inputType", required: "" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleInputTypeChange },
                      model: {
                        value: _vm.form.inputType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "inputType", $$v)
                        },
                        expression: "form.inputType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "manual" } }, [
                        _vm._v("手动添加"),
                      ]),
                      _c("el-radio", { attrs: { label: "batch" } }, [
                        _vm._v("批量录入"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.inputType === "manual"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "渠道", prop: "channelId", required: "" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            "filter-method": _vm.dataFilter,
                            clearable: "",
                            placeholder: "请选择渠道",
                          },
                          on: { "visible-change": _vm.handleVisibleChange },
                          model: {
                            value: _vm.form.channelId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "channelId", $$v)
                            },
                            expression: "form.channelId",
                          },
                        },
                        _vm._l(_vm.channelShowOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: _vm.getChannelLabel(item),
                              value: String(item.id),
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.inputType === "manual"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "UID", prop: "uid", required: "" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            placeholder: "请输入UID，多个用逗号分隔",
                            maxlength: "999",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.uid,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "uid", $$v)
                            },
                            expression: "form.uid",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.form.inputType === "batch"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "导入文件",
                          prop: "importFile",
                          required: "",
                        },
                      },
                      [
                        _c("div", { staticClass: "import-section" }, [
                          _c(
                            "div",
                            { staticClass: "template-download" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("文件模板："),
                              ]),
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.downloadTemplate },
                                },
                                [
                                  _vm._v(
                                    "\n                升级黑名单录入模板.xlsx\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "file-upload" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("选择文件："),
                              ]),
                              _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  attrs: {
                                    "auto-upload": false,
                                    "before-upload": _vm.beforeUpload,
                                    "on-change": _vm.onFileChange,
                                    "show-file-list": false,
                                    accept: ".xlsx,.xls",
                                    limit: 1,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                    },
                                    [_vm._v("选择文件")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [_vm._v("只能上传 xlsx/xls 文件")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.importFile
                            ? _c(
                                "div",
                                { staticClass: "uploaded-file" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("已上传："),
                                  ]),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "success", closable: "" },
                                      on: { close: _vm.removeFile },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.form.importFile.name) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入备注（可选）",
                      maxlength: "999",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }